/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import MicIcon from "@mui/icons-material/Mic";

function AsrStateText() {
  const [timeout, setTimeoutVal] = useState(false);
  const asrState = useSelector((state) => state.asrState.asr);

  useEffect(() => {
    setTimeoutVal(true);
  }, [asrState]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeoutVal(false);
      clearInterval(interval);
    }, 10000);

    return () => {
      clearInterval(interval);
    };
  }, [asrState]);

  return (
    <Grid
      item
      sx={{
        position: "fixed",
        bottom: 0,
        textAlign: "center",
        zIndex: 100,
        left: "50%",
        transform: "translate(-50%, 0)",
      }}
    >
      {asrState != null && asrState.length > 0 && timeout && (
        <Button
          variant='contained'
          color='secondary'
          sx={{
            background: "rgba(97, 97, 97, 0.6)",
            border: "2px solid #FFFFFF",
            boxShadow: "0px 8px 10px rgba(0, 0, 0, 0.4)",
            borderRadius: "6px",
          }}
          startIcon={<MicIcon />}
        >
          {asrState}
        </Button>
      )}
    </Grid>
  );
}

export default AsrStateText;
